<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('meter.suggest_resource')"
    icon="res-suggestsalert"
    :res-name="detailData.name"
    :actions="params.actions"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :res-id="data.id"
      :id="listId"
      :on-manager="onManager"
      :getParams="getParams"
      @side-page-trigger-handle="sidePageTriggerHandle"
      @init-side-page-tab="initSidePageTab"
      @single-refresh="singleRefresh" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import SuggestsalertDetail from './Detail'
import SuggestsalertRule from './Rules'

export default {
  name: 'SuggestsAlertSidePage',
  components: {
    Actions,
    SuggestsalertDetail,
    SuggestsalertRule,
  },
  mixins: [WindowsMixin, SidePageMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.text_185'), key: 'suggestsalert-detail' },
        { label: this.$t('meter.match_rules'), key: 'suggestsalert-rule' },
        { label: this.$t('bill.text_186'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForSuggestsAlertSidePage'
        case 'suggestsalert-rule':
          return 'SuggestsalertRuleSidePage'
        default:
          return ''
      }
    },
    getParams () {
      if (this.params.windowData.currentTab === 'suggestsalert-rule') {
        return {
          res_id: this.detailData.res_id,
        }
      }
      return {}
    },
  },
}
</script>
